export default {"src":"/_next/static/media/typescript_wordmark_logo_5c10572ef1.8ee6fb48.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};